export const analyticsEvents = {
  TOWN_FROM: {
    SELECT: 'search_town_from_select',
    OPEN: 'search_town_from_open',
  },
  COUNTRY_TO: {
    SELECT: 'search_country_to_select',
  },
  TOWNS_TO: {
    OPEN: 'search_towns_to_open',
    CLOSE: 'search_towns_to_close',
    CLICK: 'search_towns_to_click',
    NO_TOWN_FROM: 'search_towns_to_no_town_from',
    COUNTRY_TO_CLICK: 'search_country_to_click',
  },
  DATES: {
    SELECT: 'search_dates_select',
    OPEN: 'search_dates_open',
    CLOSE: 'search_dates_close',
    CLICK: 'search_dates_click',
    CLEAR: 'search_dates_clear',
    DIRECTION_CLICK: 'search_dates_direction_click',
    NO_TOWN_FROM_OR_TO: 'search_no_town_from_or_to',
  },
  PASSENGERS: {
    SELECT: 'search_passengers_select',
    CLOSE: 'search_passengers_close',
    CLICK: 'search_passengers_click',
    INVALID: 'search_passengers_invalid',
  },
  START_SEARCH_WITH_OLD_DATA: 'search_start_with_old_data',
  INVALID: 'search_invalid',
};
